export const getPeriodCompositionKey = (periodRows = []) => (
    periodRows
        .map((row) => ({
            periodId: Number(row.periodId),
            enabled: row.enabled !== false,
            scheduleDraftId: row.scheduleDraftId == null ? null : Number(row.scheduleDraftId)
        }))
        .filter((row) => Number.isFinite(row.periodId))
        .sort((a, b) => a.periodId - b.periodId)
        .map((row) => `${row.periodId}:${row.enabled ? 'on' : 'off'}:${row.scheduleDraftId ?? 'live'}`)
        .join('|')
);
